import type { RegisteredParticipant } from '@/state/stores/registrationStore';

/**
 * Участники, у которых в сторе выключен чемпионат (гость / фестиваль).
 * Если кто-то из пары переключился в гостя, а вторая строка в сторе ещё «чемпион»,
 * по copartnerId всё равно не шлём ссылку на гостя — иначе PATCH снова утащит ULID.
 */
export function participantIdsInGuestMode(
  registeredParticipants: RegisteredParticipant[],
): Set<string> {
  return new Set(
    registeredParticipants
      .filter((p) => p.isChampionshipParticipant !== true)
      .map((p) => p.id),
  );
}
